import { render, staticRenderFns } from "./broadcastselector.vue?vue&type=template&id=2dfc3322"
import script from "./broadcastselector.vue?vue&type=script&lang=ts"
export * from "./broadcastselector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports